import api from '../../config/axios.js';

const emptyMoney = { raw: 0, formatted: 'R$ 0,00' };

const state = {
    goals: [],
    summary: {
        active_count: 0,
        active_limit: 10,
        slots_remaining: 10,
        total_target: emptyMoney,
        total_saved: emptyMoney,
        total_remaining: emptyMoney,
        next_goal_id: null,
    },
    pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
        from: null,
        to: null,
    },
    loading: false,
    error: '',
};

const getters = {
    getFinancialGoals: state => state.goals,
    getFinancialGoalsSummary: state => state.summary,
    getFinancialGoalsPagination: state => state.pagination,
    getFinancialGoalsLoading: state => state.loading,
    getFinancialGoalsError: state => state.error,
};

const errorMessage = (error, fallback) => {
    const errors = error?.response?.data?.errors;
    if (errors && typeof errors === 'object') {
        const first = Object.values(errors).flat().find(Boolean);
        if (first) return String(first);
    }
    return error?.response?.data?.message || fallback;
};

const actions = {
    async fetchFinancialGoals({ commit }, params = {}) {
        commit('setFinancialGoalsLoading', true);
        commit('setFinancialGoalsError', '');
        try {
            const response = await api.axios.get('/api/finance/goals', { params });
            const payload = response.data || {};
            commit('setFinancialGoals', Array.isArray(payload.data) ? payload.data : []);
            commit('setFinancialGoalsSummary', payload.summary || {});
            commit('setFinancialGoalsPagination', payload);
            return payload;
        } catch (error) {
            if (api.axios.isCancel(error)) return;
            commit('setFinancialGoals', []);
            commit('setFinancialGoalsError', errorMessage(error, 'Não foi possível carregar suas metas.'));
            throw error;
        } finally {
            commit('setFinancialGoalsLoading', false);
        }
    },

    async fetchFinancialGoal(_context, id) {
        const response = await api.axios.get(`/api/finance/goals/${id}`);
        return response.data;
    },

    async createFinancialGoal(_context, payload) {
        const response = await api.axios.post('/api/finance/goals', payload);
        return response.data;
    },

    async updateFinancialGoal(_context, { id, data }) {
        const response = await api.axios.patch(`/api/finance/goals/${id}`, data);
        return response.data;
    },

    async deleteFinancialGoal(_context, id) {
        const response = await api.axios.delete(`/api/finance/goals/${id}`);
        return response.data;
    },

    async addFinancialGoalContribution(_context, { id, data }) {
        const response = await api.axios.post(`/api/finance/goals/${id}/contributions`, data);
        return response.data;
    },

    async deleteFinancialGoalContribution(_context, { goalId, contributionId }) {
        const response = await api.axios.delete(`/api/finance/goals/${goalId}/contributions/${contributionId}`);
        return response.data;
    },

    async completeFinancialGoal(_context, id) {
        const response = await api.axios.post(`/api/finance/goals/${id}/complete`);
        return response.data;
    },

    async reopenFinancialGoal(_context, id) {
        const response = await api.axios.post(`/api/finance/goals/${id}/reopen`);
        return response.data;
    },
};

const mutations = {
    setFinancialGoals(state, goals) {
        state.goals = goals;
    },
    setFinancialGoalsSummary(state, summary) {
        state.summary = { ...state.summary, ...summary };
    },
    setFinancialGoalsPagination(state, payload) {
        state.pagination = {
            current_page: Number(payload.current_page || 1),
            last_page: Number(payload.last_page || 1),
            per_page: Number(payload.per_page || 10),
            total: Number(payload.total || 0),
            from: payload.from || null,
            to: payload.to || null,
        };
    },
    setFinancialGoalsLoading(state, loading) {
        state.loading = loading;
    },
    setFinancialGoalsError(state, error) {
        state.error = error;
    },
};

export default { state, getters, actions, mutations };
